import classNames from 'classnames';
import React from 'react';
import ClientTitle from './comps/client-title';
import './index.scss';
import gtm from 'eco-design-reliance/gtm';

interface EfFooterNavV2Sub1ItemProps {
    /**
     * 文章链接
     */
    url?: string;
    /**
     * heading
     */
    heading?: string;
}

interface EfhFooterNavV2Sub1ItemProps {
    /**
     * title
     */
    name?: React.ReactNode;
    /**
     * 子内容列表
     */
    subs?: EfFooterNavV2Sub1ItemProps[];
}

export interface EfhFooterNavV2Props {
    /**
     * 主题色
     */
    theme?: 'white' | 'black' | 'gray';
    /**
     * 列表
     */
    items: EfhFooterNavV2Sub1ItemProps[];
    /**
     * 样式名
     */
    className?: string;
}

/**
 *
 * 底部导航-v1
 */
const EfhFooterNavV2: React.FC<EfhFooterNavV2Props> = ({ theme, items = [], className }) => {
    const prefixCls = `ef-footer-nav-v2`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-theme-${theme}`]: theme,
    });

    return (
        <nav className={classes}>
            {items.map((itemA: EfhFooterNavV2Sub1ItemProps, index1: number) => {
                const listA = itemA.subs || [];
                return (
                    <div key={index1} className={`${prefixCls}-column`}>
                        <ClientTitle prefixCls={prefixCls} title={itemA.name} />
                        <ul className={`${prefixCls}-sub-list`}>
                            {listA.map((itemC1: EfFooterNavV2Sub1ItemProps, index2: number) => {
                                return (
                                    <li key={index2} className={`${prefixCls}-sub-item`}>
                                        <a
                                            className={`${prefixCls}-sub-href GtmModuleData-btn-href footer-nav-i-${index1}-${index2}`}
                                            onClick={() => {
                                                gtm.push({
                                                    event: 'uaEvent',
                                                    event_name: 'bottom_navigation',
                                                    list_name: itemA.name,
                                                    navigation_name: itemC1.heading,

                                                    __btn_id1: `footer-nav-i-${index1}-${index2}`,
                                                    __btn_id2: itemC1.url,
                                                    __btn_type: 'href',
                                                });
                                            }}
                                            href={itemC1.url}
                                        >
                                            {itemC1.heading}
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                );
            })}
        </nav>
    );
};

export default EfhFooterNavV2;
